export default __webpack_public_path__ + "static/media/img.62c10082.png";